import React from 'react';
import { PaymentRequest } from '../types/booking.types';

interface PaymentRequestsTabProps {
  paymentRequests: PaymentRequest[];
  onSendRequest: () => void;
  onDeleteRequest: (requestId: number) => void;
}

const PaymentRequestsTab: React.FC<PaymentRequestsTabProps> = ({
  paymentRequests,
  onSendRequest,
  onDeleteRequest,
}) => {
  const getStatusColor = (status: string): string => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-700';
      case 'pending':
        return 'bg-yellow-100 text-yellow-700';
      default:
        return 'bg-red-100 text-red-700';
    }
  };

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800 flex items-center">
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Payment Requests Sent
        </h3>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition-all text-sm font-medium"
          onClick={onSendRequest}
        >
          📩 Send Payment Request
        </button>
      </div>
      <div className="overflow-x-auto bg-white border border-gray-200 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">#</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Amount</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Status</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Date</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paymentRequests.length > 0 ? (
              paymentRequests.map((request, index) => (
                <tr className="border-b border-gray-100 hover:bg-gray-50" key={request.id}>
                  <td className="py-3 px-4 font-semibold text-gray-700">{index + 1}</td>
                  <td className="py-3 px-4 font-bold text-gray-800">
                    ₹{parseFloat(String(request.requested_amount || 0)).toFixed(2)}
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(request.request_status)}`}>
                      {request.request_status}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-gray-600">{new Date(request.created_at).toLocaleDateString()}</td>
                  <td className="py-3 px-4">
                    <button
                      onClick={() => onDeleteRequest(request.id)}
                      className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-xs font-medium"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="py-8 text-center text-gray-500">
                  No payment requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentRequestsTab;
